import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createElementVNode("div", {
        class: _normalizeClass(["custom-cursor", { '--dark': _ctx.isDark }])
      }, [
        _createElementVNode("div", {
          class: "custom-cursor__bubble",
          style: _normalizeStyle(_ctx.computedStyle.bubble)
        }, _toDisplayString(_ctx.displayText), 5)
      ], 2)
    ])),
    _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ eventListeners: _ctx.eventListeners, isHover: _ctx.isHover, shrink: _ctx.shrink })))
  ], 64))
}